import MojitoPresentation from 'mojito/presentation';

import {getExtendedFrameIntentData, LOGIN_INTO_ACCOUNT, ON_CLOSE_CASHIER} from '#core/utils/intent-factory.js';
import {OpenUrlStrategies} from '#core/utils/intent-validation.cjs';
import {removeContextProperties} from '#core/utils/config-utils.js';
import {OPEN_BET_PROPOSALS} from '#core/utils/intent-types.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './intents.schema.yaml';

export const Intents = {
    LOGIN: null,
    LOGOUT: null,
    DEPOSIT: null,
    REGISTER: null,
    FORGOT_DETAILS: null,

    COOKIE_CONSENT: null,
    HELP: null,
    BET_HISTORY: null,
    OPEN_BETS: {
        type: MojitoPresentation.Base.Intent.Types.SHOW_SLIDING_OPEN_BETS,
        data: {
            authRequired: true,
        },
    },
    BET_PROPOSALS: {
        type: OPEN_BET_PROPOSALS,
    },
    AZ_MENU: {
        type: MojitoPresentation.Base.Intent.Types.SHOW_SLIDING_AZ_MENU,
    },
    SPORTSBOOK_MOUNTED: null, // TODO: Rename to APP_MOUNTED and change behavior to trigger only after mount promise is fulfilled
    MOJITO_DEPOSIT: {
        type: MojitoPresentation.Base.Intent.Types.SHOW_ACCOUNT_POPUP,
        data: {
            selectedMenuId: 'deposit-portal',
        },
    },
    // Bonus indicators read more links
    EARLY_PAYOUT_READ_MORE: null,
    ODDS_BOOST_READ_MORE: null,
    ACCA_BOOST_READ_MORE: null,
    ACCA_INSURANCE_READ_MORE: null,
    ENHANCED_EW_TERMS_READ_MORE: null,
    BEST_ODDS_GUARANTEED_READ_MORE: null,
    EVENT_TRIGGERED_READ_MORE: null,
};

function getHandledIntent(intent, title, onCloseHandler) {
    if (!intent) return null;

    if (intent.strategy === OpenUrlStrategies.FRAME) {
        return {
            ...intent,
            data: getExtendedFrameIntentData(intent.data, title, onCloseHandler),
        };
    }

    return intent;
}

class IntentsFeature extends AbstractFeature {
    get name() {
        return 'Intents';
    }

    get configSchema() {
        return SCHEMA;
    }

    setupConfigs(globalConfig, options, filterFn) {
        super.setupConfigs(removeContextProperties(globalConfig), options, filterFn);

        const {
            login,
            logout,
            deposit,
            register,
            forgotDetails,
            cookieConsent,
            help,
            sportsbookMounted,
            betHistory,
            earlyPayoutReadMore,
            oddsBoostReadMore,
            accaBoostReadMore,
            accaInsuranceReadMore,
            enhancedEachWayTermsReadMore,
            bestOddsGuaranteedReadMore,
            eventTriggeredReadMore,
        } = this.config;

        // TODO: Sort out with standard labels & translations
        Intents.LOGIN = getHandledIntent(login, '$USER_AUTHENTICATION_INFO.LOGIN', LOGIN_INTO_ACCOUNT);
        Intents.LOGOUT = getHandledIntent(logout);
        Intents.DEPOSIT = getHandledIntent(deposit, '$MY_ACCOUNT_PAGE.MENU_ITEMS.DEPOSIT', ON_CLOSE_CASHIER);
        Intents.REGISTER = getHandledIntent(register, '$USER_AUTHENTICATION_INFO.SIGNUP', LOGIN_INTO_ACCOUNT);
        Intents.FORGOT_DETAILS = getHandledIntent(
            forgotDetails,
            '$LOGIN_DIALOG.USERNAME_PASSWORD.FORGOT_DETAILS',
            LOGIN_INTO_ACCOUNT
        );
        Intents.COOKIE_CONSENT = getHandledIntent(cookieConsent, '$DBX.COOKIE_POLICY_TITLE');
        Intents.HELP = getHandledIntent(help);
        Intents.BET_HISTORY = getHandledIntent(betHistory);
        Intents.SPORTSBOOK_MOUNTED = getHandledIntent(sportsbookMounted);
        // Bonus indicators read more links
        Intents.EARLY_PAYOUT_READ_MORE = getHandledIntent(earlyPayoutReadMore);
        Intents.ODDS_BOOST_READ_MORE = getHandledIntent(oddsBoostReadMore);
        Intents.ACCA_BOOST_READ_MORE = getHandledIntent(accaBoostReadMore);
        Intents.ACCA_INSURANCE_READ_MORE = getHandledIntent(accaInsuranceReadMore);
        Intents.ENHANCED_EW_TERMS_READ_MORE = getHandledIntent(enhancedEachWayTermsReadMore);
        Intents.BEST_ODDS_GUARANTEED_READ_MORE = getHandledIntent(bestOddsGuaranteedReadMore);
        Intents.EVENT_TRIGGERED_READ_MORE = getHandledIntent(eventTriggeredReadMore);
    }
}

new IntentsFeature(allFeatures);
